<template>
    <a-modal :visible="isShow" width="960px" title="添加寄件人信息" :footer="null" @cancel="cancel" class="sender_modal">
        <a-form-model :model="senderForm" ref="senderForm" :rules="rules" labelAlign="left" class="underline_input_form">
            <a-form-model-item label="寄件人姓名" prop="name">
                <a-input v-model="senderForm.name" />
            </a-form-model-item>
            <a-form-model-item label="联系电话" prop="tel">
                <a-input v-model="senderForm.tel" />
            </a-form-model-item>
        </a-form-model>
        <div class="btn_confirm">
            <a-button type="primary" @click="ok">确认</a-button>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: 'AddSenderModal',
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
        type: Boolean,
        },
    },
    data () {
        return {
        senderForm: {
            name: '',
            tel: ''
        },
        rules: {
            name: [
                { required: true, message: '请输入寄件人姓名', trigger: ['blur','change'] },
            ],
            tel: [
                { required: true, message: '请输入联系电话', trigger: ['blur','change'] },
                // { validator: this.$validate.mobile, trigger: ['blur','change'] }
            ],
        },
        }
    },
    created () {
    },
    methods: {
        ok () {
            this.$refs.senderForm.validate(valid => {
                if (!valid) return

                var _this = this;

                _this.$util.api('/address/send/submit',{
                    seller_name: _this.senderForm.name,
                    tel: _this.senderForm.tel,
                    is_default: 1
                },function(res){
                    _this.$message[res.code == 10000 ? 'success' : 'error'](res.msg);

                    if(res.code == 10000){
                        _this.$emit('ok');
                        _this.cancel();
                    }
                });
            })
        },
        cancel () {
            this.senderForm.name=''
            this.senderForm.tel=''
            this.$emit('hidden', false)
        },
    },
}
</script>

<style scoped>
.sender_modal >>> .ant-modal-header {
    border-top: 5px solid #fd5902;
    text-align: center;
}

.sender_modal >>> .ant-form-item:nth-child(n + 2) {
    margin-bottom: 0;
    margin-top: 35px;
}
.btn_confirm {
    text-align: center;
    margin-top: 20px;
}
.btn_confirm >>> .ant-btn {
    height: 34px;
    padding: 0 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/address/AddSenderModal.vue